import { ucEventHandler } from "./ucEventHandler.js";

window.addEventListener("ucEvent", ucEventHandler);